import Api from  "@/services/AxiosAPI";
export default {

  contact(data) {
    const form = new FormData();
    form.append("name", data.firstName);
    form.append("company", data.Company);
    form.append("email", data.email);
    form.append("phone", data.phone);
    form.append("message", data.message);
    form.append("reply_by", data.prefer);
 //REPLY_TO
          return Api.postData('/contactus', form)
            .then(response => {
              return response
            });
      


  }
}